import { jsx as e } from "react/jsx-runtime";
import { Box as m } from "@mui/material";
import { mergeClassNames as t } from "./mergeClassNames.mjs";
import { progressBarContainerClasses as p } from "./constants4.mjs";
const c = ({
  children: r,
  sx: o,
  className: s,
  ...a
}) => /* @__PURE__ */ e(
  m,
  {
    ...a,
    sx: {
      position: "relative",
      display: "grid",
      rowGap: "200px",
      maxWidth: "100%",
      flexDirection: "column",
      gap: (i) => i.spacing(1.5),
      ...o
    },
    className: t([p.root, s]),
    children: r
  }
);
export {
  c as ProgressBarContainer
};
//# sourceMappingURL=index131.mjs.map
